import React from 'react';

import { useInfluencerId } from '@client/new/contexts/InfluencerIdContext';
import { useInfluencer } from '@client/new/hooks/use-influencer';
import * as enums from '@playbook-technologies/common-enums';

import { PayPalPaymentMethod } from './PayPalPaymentMethod';
import { StripePaymentMethod } from './StripePaymentMethod';
import { WirePaymentMethod } from './WirePaymentMethod';

export const PaymentMethod: React.FC = () => {
  const influencerId = useInfluencerId();
  const { influencer } = useInfluencer({
    creatorId: influencerId,
  });

  switch (influencer?.paymentMethod) {
    case enums.Influencer.PaymentMethod.StripeConnect.value:
      return <StripePaymentMethod />;
    case enums.Influencer.PaymentMethod.PayPal.value:
      return <PayPalPaymentMethod />;
    case enums.Influencer.PaymentMethod.WireTransfer.value:
      return <WirePaymentMethod />;
    default:
      return <StripePaymentMethod />;
  }
};
